<template lang='pug'>
  .rewards-container
    heading-section(:title='title', :description='description' :hideDescription='hideDescription')
    .rewards(v-if='rewards.length > 0')
      ProductsCarousel(
        class='sep-carousel js-rewards-carousel reward-carousel'
        :carousel-options='carouselOptions'
        :entity-options='entityOptions'
        :products='products'
        :rewards='rewards'
        :variants='variants'
        :autoplay='false'
      )
    a.view-rewards(:href='viewRewardsPath')
      .text(v-text='$t("viewAll")')
      .arrow
</template>

<i18n>
{
  "lng_en": {
    "viewAll": "View All Rewards"
  },
  "lng_id": {
    "viewAll": "Lihat Semua Rewards"
  },
  "lng_th": {
    "viewAll": "ดูของสมนาคุณทั้งหมด"
  },
  "lng_zh": {
    "viewAll": "瀏覽所有獎賞"
  },
  "lng_ko": {
    "viewAll": "모든 리워드 보기"
  }
}
</i18n>

<script>
import { mapGetters } from 'vuex'
import HeadingSection from './heading.vue'
import ProductsCarousel from '@/components/products/products-carousel.vue'

export default {
  components: {
    HeadingSection,
    ProductsCarousel
  },
  props: {
    title: String,
    description: String,
    hideDescription: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      rawRewards: [],
      rawVariants: [],
      entityOptions: {},
      variants: [],
      products: [],
      carouselOptions: {
        size: 'md',
        items: 3,
        sliderClass: `rewards-carousel`
      }
    }
  },

  computed: {
    ...mapGetters(['isMobileApp']),
    rewards () {
      return this.rawRewards.slice(0, 3).map(reward => {
        const variant = this.rawVariants.find(v => v.id === reward.relationships.variant.data.id)

        return {
          id: reward.id,
          icon: variant.attributes['default-image-urls'][0],
          brand: variant.attributes['brand-name'],
          description: variant.attributes['product-name'],
          points: reward.attributes['point-value']
        }
      })
    },
    viewRewardsPath () {
      return (this.isMobileApp ? 'sephora://account/rewards_boutique' : '/rewards-boutique')
    }
  },

  created () {
    this.fetchRewards()
  },

  methods: {
    fetchRewards () {
      const url = '/api/v2/redeemables?include=variant'
      return window.axios.get(url).then((response) => {
        const partitioned = this.partitionByAvailability(response.data.data)
        this.rawRewards = this.sortByCreationDate(partitioned)
        this.rawVariants = response.data.included.filter(i => i.type === 'variants')
      }).catch(() => {
        console.log('Error fetching rewards')
      })
    },
    partitionByAvailability (rawData) {
      const [available, _fullyRedeemed] = // eslint-disable-line no-unused-vars
        rawData
          .reduce((result, i) => {
            const index = this.isAvailable(i) ? 0 : 1
            result[index].push(i)
            return result
          },
          [[], []])
      return available
    },
    isAvailable (reward) {
      return reward.attributes['redemptions-left'] > 0 || reward.attributes['is-teaser']
    },
    sortByCreationDate (rawData) {
      return rawData.sort((a, b) => {
        return new Date(b.attributes['created-at']) - new Date(a.attributes['created-at'])
      })
    }
  }
}
</script>

<style lang='scss' scoped>
  .rewards-container {
    padding-bottom: 30px;
    padding-top: 30px;

    @include media-breakpoint-up(xl) {
      align-content: space-between;
      display: flex;
      flex-flow: column wrap;
      height: 350px;
      justify-content: center;
      margin: 0 auto;
    }

    > .rewards {
      display: flex;
      justify-content: space-around;
      margin: 20px 0 0;
      text-align: left;

      @include media-breakpoint-up(sm) {
        margin-left: auto;
        margin-right: auto;
        width: 585px;
      }

      @include media-breakpoint-up(xl) {
        margin: 0;
        min-width: auto;
        min-height: 218px;
        order: 3;
      }

      .reward-carousel {
        opacity: 1;
      }
    }
  }

  .carousel-list {
    > .reward {
      width: 135px;
      margin-left: 10px;

      @include media-breakpoint-up(sm) {
        width: 165px;
        margin-left: 0;
      }
    }
  }

  .reward {
    &:last-child {
      margin-right: 10px;

      @include media-breakpoint-up(sm) {
        margin-right: 0;
      }
    }

    > .img {
      background: #fff;
      height: 140px;

      @include media-breakpoint-up(sm) {
        height: 165px;
      }
    }

    > .brand, .points {
      @include font-weight-medium;
      text-transform: capitalize;
    }
  }

  .view-rewards {
    @include font-weight-medium;
    margin-top: 40px;
    display: flex;
    justify-content: center;

    @include media-breakpoint-up(xl) {
      justify-content: flex-start;
      order: 2;
      width: 300px;
    }

    > .arrow {
      width: 0;
      height: 0;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-left: 6px solid red;
      margin-top: 2px;
      margin-left: 7px;
    }
  }
</style>
